import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入创建的路由页面
import Home from '../components/home.vue'
const Attendance = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/attendance.vue')
const SEvaluation = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/st-evaluation.vue')
const Leave = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/leave.vue')
const LeaveList = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/leave-list.vue')
import LeaveDetail from '../components/attendance/leave-detail.vue'
import Notice from '../components/notice/notice.vue'
import NoticeDetail from '../components/notice/notice-detail.vue'
const AttendDetail = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/attend-detail.vue')
const AttendInquire = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/attend-inquire.vue')
const CallName = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/call-name.vue')
const Called = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/called.vue')
const Score = () => import(/* webpackChunkName: "score" */ '../components/score/score.vue')
const TScoreList = () => import(/* webpackChunkName: "score" */ '../components/score/tscore-list.vue')
const TScoreDetail = () => import(/* webpackChunkName: "score" */ '../components/score/tscore-detail.vue')
const ScoreSubject = () => import(/* webpackChunkName: "score" */ '../components/score/score-subject.vue')
import ScoreList from '../components/score/score-list.vue'
const ScoreReport = () => import(/* webpackChunkName: "score" */ '../components/score/score-report.vue')
const ScoreReportAll = () => import(/* webpackChunkName: "score" */ '../components/score/score-report-all.vue')
const ScoreAllSubject = () => import(/* webpackChunkName: "score" */ '../components/score/score-allSubject-teacher.vue')
const ScoreSubjectTea = () => import(/* webpackChunkName: "score" */ '../components/score/score-subject-teacher.vue')
const EvalDetail = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-detail.vue')
const EvalLook = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-look.vue')
const EvalHistory = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-history.vue')
const EvalDone = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-done.vue')
import TNoticeUnread from '../components/notice/T-notice-unread.vue'
import Ucenter from '../components/user/ucenter.vue'
// import SelectLoginadmin from '../components/user/SelectLoginadmin.vue'
import LoginStudent from '../components/user/loginStudent.vue'
import LoginTeacher from '../components/user/loginTeacher.vue'
import EditorMyIntro from '../components/user/editorMyIntro.vue'
import Login from '../components/user/login.vue'
import ChangePwd from '../components/user/changePwd.vue'
import Layout from '../components/layout.vue'

const TEvaluation = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/tech-evaluation.vue')
const EvalTechHistory = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-history-tech.vue')
const EvalQuestionDetail = () => import(/* webpackChunkName: "evaluation" */ '../components/evaluation/eval-question-detail.vue')
const AttendStudent = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/attend-student.vue')
const AttendTeacher = () => import(/* webpackChunkName: "attendance" */ '../components/attendance/attend-teacher.vue')
const AssessStudent = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-student.vue')
const AssessTeacher = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-teacher.vue')
const AssessStudentEntry = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-student-entry.vue')
const AssessTeacherEntry = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-teacher-entry.vue')
const AssessRank = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-rank.vue')
const AssessQuality = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-quality.vue')
const AssessComplain = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-complain.vue')
const AssessComplainDetail = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-complain-detail.vue')
const AssessClassStatistics = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-class-statistics.vue')
const AssessStudentStatistics = () => import(/* webpackChunkName: "assessment3" */ '../components/assessment/assess-student-statistics.vue')

const AssessAdmin = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin.vue')
const AssessAdminEntry = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-entry.vue')
const AssessAdminSchoolStatistics = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-school-statistics.vue')
const AssessAdminStudentStatistics = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-student-statistics.vue')
const AssessAdminClass = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-class.vue')
const AssessAdminClassStatistics = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-class-statistics.vue')
const AssessAdminClassAdd = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-class-add.vue')
const AssessAdminClassRecord = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-class-record.vue')
const AssessAdminRecord = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-record.vue')
const AssessAdminRecordContent = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-record-content.vue')
const AssessAdminRecordTeacher = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-record-teacher.vue')
const AssessAdminRecordClass = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-record-class.vue')
const AssessAdminRecordContentDetail = () => import(/* webpackChunkName: "admin" */ '../components/assessment/assess-admin-record-content-detail.vue')

const AssessTeacherRecord = () => import(/* webpackChunkName: "assessment4" */ '../components/assessment/assess-teacher-record.vue')
const AssessTeacherClassAdd = () => import(/* webpackChunkName: "assessment4" */ '../components/assessment/assess-teacher-class-add.vue')


import AssessStudentAppealEntry from '../components/assessment/assess-student-appeal-entry.vue'
import AssessStudentAppeal from '../components/assessment/assess-student-appeal.vue'
import AssessStudentMsg from '../components/assessment/assess-student-msg.vue'
import AssessStudentMsgDetail from '../components/assessment/assess-student-msg-detail.vue'
import AssessStudentAppealDetail from '../components/assessment/assess-student-appeal-detail.vue'
import AssessStudentMsgAdd from '../components/assessment/assess-student-msg-add.vue'


const CampusDetails = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/campus-details.vue')
const CampusTask = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/capush-task.vue')
const StudentAssess = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/common/student-assess.vue')
const GloryUpload = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/glory-upload.vue')
const UploadImg = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/uploadImg.vue')
const InfoResult = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/info-result.vue')
const AssessEnd = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/assess-end.vue')
const AssessMent = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/assess-ment.vue')
const AssessMutual = () => import(/* webpackChunkName: "newEvaluate" */ '../components/newEvaluate/assess-mutual.vue')

// 教学评价管理
const RemarkList = () => import(/* webpackChunkName: "remarks" */ '../components/remark/RemarkList.vue'); // 评价管理
const RemarkForm = () => import(/* webpackChunkName: "remarks" */ '../components/remark/RemarkForm.vue'); // 评价表单提交

// 数据中心
const DateCenter = () => import('../components/dataCenter/data-center.vue')
const DataSummary = () => import('../components/dataCenter/data-summary.vue')
const Beike = () => import('../components/dataCenter/beike/beike.vue')
const DownloadSource = () => import('../components/dataCenter/beike/download-source.vue')
const DownloadPaper = () => import('../components/dataCenter/beike/download-paper.vue')
const LocalSource = () => import('../components/dataCenter/beike/local-source.vue')
const Test = () => import('../components/dataCenter/exam/test.vue')
const Work = () => import('../components/dataCenter/exam/work.vue')
const Exam = () => import('../components/dataCenter/exam/exam.vue')
const Judgment = () => import('../components/dataCenter/judge/judgment.vue')
const JudgeData = () => import('../components/dataCenter/judge/judge-data.vue')
const QualityJudge = () => import('../components/dataCenter/judge/quality-judge.vue')
const Growth = () => import('../components/dataCenter/judge/growth.vue')
const OfficialAccount = () => import('../components/dataCenter/official-account.vue')
const LessonPeriod = () => import('../components/dataCenter/lesson-period.vue')

const TimeTable = () => import('../components/Timetable.vue') // 课表查询

// 使用路由实例插件
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this,location).catch((err)=>err)
}

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  linkActiveClass: 'active',
  routes:[
  

    { name:'Home', path:'/', component: Home },                                        //入口 
    // { name:'SelectLoginadmin', path:'/select-admin', component: SelectLoginadmin },                                        //入口 
    { name:'LoginStudent', path:'/login-student', component: LoginStudent },                                        //入口 
    { name:'LoginTeacher', path:'/login-teacher', component: LoginTeacher },                                        //入口 
    { name:'EditorMyIntro', path:'/editor-my-intro', component: EditorMyIntro },                                        //入口 
    { name:'Ucenter', path:'/ucenter', component: Ucenter },                           //个人中心
    { name:'Login', path:'/login', component: Login },                                 //绑定账号
    { name:'ChangPwd', path:'/changePwd', component: ChangePwd },                                  //修改密码
    { name:'Notice', path:'/notice', component :Notice },                              //公告通知
    { name:'NoticeDetail', path:'/notice-detail/:id', component:NoticeDetail },            //公告通知详情页
    { name:'TNoticeUnread', path:'/T-notice-unread/:id',component: TNoticeUnread },        //发布者未读详情
    { name:'LeaveDetail', path:'/leave-detail', component: LeaveDetail },              //请假申请信息详情
    { name:'ScoreList', path:'/score-list', component: ScoreList },                    //往期考试
    { name:'Assess-student-appeal-entry', path: '/assess-student-appeal-entry',component: AssessStudentAppealEntry },  //申诉留言入口
    { name:'Assess-student-appeal', path: '/assess-student-appeal',component: AssessStudentAppeal },  //申诉入口
    { name:'Assess-student-msg', path: '/assess-student-msg',component: AssessStudentMsg },  //留言入口
    { name:'Assess-student-msg-detail', path: '/assess-student-msg-detail',component: AssessStudentMsgDetail },  //留言回复详情页入口
    { name:'Assess-student-appeal-detail', path: '/assess-student-appeal-detail',component: AssessStudentAppealDetail },  //申诉回复详情页入口
    { name:'Assess-student-msg-add', path: '/assess-student-msg-add',component: AssessStudentMsgAdd },  //申诉回复详情页入口
    {
      name: 'teacher',
      path:'/teacher',
      component: Layout,
      children:[
		    { name:'Timetable', path:'timetable', component: TimeTable },  // 课表查询
        { name:'Leave-teacher', path:'leave-list', component: LeaveList },                    //请假申请列表
        { name:'Attendance-teacher', path: 'attendance', component: Attendance },                 //考勤中心
        { name:'Evaluation-teacher', path: 'tech-evaluation', component: TEvaluation },
        { name:'Score-teacher', path:'tscore-list', component: TScoreList },              //成绩查询列表（教师的）
        { name:'TScoreDetail', path:'tscore-detail', component: TScoreDetail },           //成绩查询详情（教师的）
        { name:'ScoreSubject-teacher', path:'score-subject', component: ScoreSubject },           //成绩查询(单科)
        { name:'Score-allSubject-teacher', path:'score-allSubject', component: ScoreAllSubject }, //成绩查询(单科)
        { name:'Score-subject-teacher', path:'score-subject-tea', component: ScoreSubjectTea },           //成绩查询(单科)
        { name:'ScoreReport', path:'score-report', component: ScoreReport },              //成绩单(单科)
        { name:'ScoreReportAll', path:'score-report-all', component: ScoreReportAll },    //成绩单(全科)
        { name:'AttendDetail', path:'attend-detail', component: AttendDetail },           //每日考勤详情页
        { name:'CallName', path:'call-name', component: CallName },                       //今日点名详情
        { name:'Called', path:'called', component: Called },                              //被点名单
        { name:'EvalTechHistory', path:'eval-history-tech', component: EvalTechHistory },   //教师历史记录
        { name:'EvalQuestionDetail', path:'eval-question-detail', component: EvalQuestionDetail }, //问答题加载更多评价
        { name:'Attend-teacher', path: 'attend-teacher',component: AttendTeacher },  //教师考勤管理入口
        { name:'Assess-teacher', path: 'assess-teacher',component: AssessTeacher },  //教师综合素质评价入口
        { name:'Assess-teacher-entry', path: 'assess-teacher-entry',component: AssessTeacherEntry },  //教师综合素质评价入口
        { name:'Assess-class-statistics', path: 'assess-class-statistics',component: AssessClassStatistics },  //教师班级统计入口
        { name:'Assess-student-statistics', path: 'assess-student-statistics',component: AssessStudentStatistics },  //教师学生统计入口
        { name:'Assess-teacher-record', path: 'assess-teacher-record',component: AssessTeacherRecord },  //教师评价记录入口
        { name:'Assess-teacher-class-add', path: 'assess-teacher-class-add',component: AssessTeacherClassAdd },  //教师新增评价记录入口
      ]
    },

    {
      name: 'student',
      path:'/student',
      component: Layout,
      children:[
        { name: 'Remark', path: 'remarks', component: RemarkList }, // 学生针对老师的评价，教学评价列表
        { name: 'RemarkForm', path: 'remark/:id', component: RemarkForm }, // 教学评价表单提交
        { name:'AssessMutual', path:'assess-mutual', component: AssessMutual }, //互评已结束
        { name:'AssessMent', path:'assess-ment', component: AssessMent },      //互评
        { name:'AssessEnd', path:'assess-end', component: AssessEnd },        //已结束自评
        { name:'InfoResult', path:'info-result', component: InfoResult },     //成绩查询
        { name:'UploadImg', path:'upload-img', component: UploadImg },         //提交图片
        { name:'GloryUpload', path:'glory-upload', component: GloryUpload },  //上传图片
        { name:'StudentAssess',path: 'stu-assess',component : StudentAssess}, //学生自评
        { name:'CampusDetails-student',path: 'stu-details',component :CampusDetails}, //新素质综合评价
        { name:'CampusTask-student',path: 'stu-task',component :CampusTask},    //评价任务
        { name:'Evaluation-student', path: 'st-evaluation', component: SEvaluation },                 //教师评价
        { name:'Leave-student', path:'leave', component: Leave },                                 //请假申请
        { name:'LeaveList-student', path:'leave-list', component: LeaveList },                    //请假申请列表
        { name:'Attendance-student', path:'attend-inquire', component: AttendInquire },        //考勤查询页
        { name:'Score-student', path:'score', component: Score },                                 //成绩查询
        { name:'ScoreSubject-student', path:'score-subject', component: ScoreSubject },           //成绩查询(单科)
        { name:'EvalDetail', path:'eval-detail/:templateId/:subjectId/:teacherId/:instanceId',component: EvalDetail },                  //教师评价页面 
        { name:'EvalLook', path:'eval-look/:templateId/:subjectId/:teacherId/:instanceId',component: EvalLook },                        //教师评价完成查看
        { name:'EvalHistory', path:'eval-history',component: EvalHistory },               //历史评价查看
        { name:'EvalDone', path:'eval-done',component: EvalDone },                         //评价完成页面
        { name:'Attend-student', path: 'attend-student',component: AttendStudent },  //学生考勤管理入口
        { name:'Assess-student', path: 'assess-student',component: AssessStudent },  //学生综合素质评价入口
        { name:'Assess-student-entry', path: 'assess-student-entry',component: AssessStudentEntry },  //学生综合素质评价入口
        { name:'Assess-rank', path: 'assess-rank',component: AssessRank },  //学生综合排名入口
        { name:'Assess-quality', path: 'assess-quality',component: AssessQuality },  //学生素质评价入口
        { name:'Assess-complain', path: 'assess-complain',component: AssessComplain },  //申诉详情页入口
        { name:'Assess-complain-detail', path: 'assess-complain-detail',component: AssessComplainDetail },  //申诉详情页入口
      ]
    },
    {
      name: 'admin',
      path: '/admin',
      component: Layout,
      children: [
        { name:'Assess-admin', path: 'assess-admin',component: AssessAdmin },  //管理员综合素质评价入口
        { name:'Assess-admin-entry', path: 'assess-admin-entry',component: AssessAdminEntry },  //管理员综合素质评价统计入口
        { name:'Assess-admin-school-statistics', path: 'assess-admin-school-statistics',component: AssessAdminSchoolStatistics },  //管理员综合素质评价学校统计入口
        { name:'Assess-admin-student-statistics', path: 'assess-admin-student-statistics',component: AssessAdminStudentStatistics },  //管理员综合素质评价学生统计入口
        { name:'Assess-admin-class', path: 'assess-admin-class',component: AssessAdminClass },  //管理员综合素质评价班级评价入口
        { name:'Assess-admin-class-statistics', path: 'assess-admin-class-statistics',component: AssessAdminClassStatistics },  //管理员综合素质评价班级评价入口
        { name:'Assess-admin-class-add', path: 'assess-admin-class-add',component: AssessAdminClassAdd },  //管理员综合素质评价新增班级入口
        { name:'Assess-admin-class-record', path: 'assess-admin-class-record',component: AssessAdminClassRecord },  //管理员综合素质评价班级评价入口
        { name:'Assess-admin-record', path: 'assess-admin-record',component: AssessAdminRecord },  //管理员综合素质评价记录情况入口
        { name:'Assess-admin-record-content', path: 'assess-admin-record-content',component: AssessAdminRecordContent, meta: { keepAlive: true } },  //管理员综合素质评价记录内容入口
        { name:'Assess-admin-record-teacher', path: 'assess-admin-record-teacher',component: AssessAdminRecordTeacher },  //管理员综合素质评价教师记录入口
        { name:'Assess-admin-record-class', path: 'assess-admin-record-class',component: AssessAdminRecordClass },  //管理员综合素质评价班级记录入口
        { name:'Assess-admin-record-content-detail', path: 'assess-admin-record-content-detail',component: AssessAdminRecordContentDetail },  //管理员综合素质评价班级记录入口
      ]
    },
    ,
    {
      name:'OfficialAccount',
      path:'/official-account',
      component:OfficialAccount  //关注公众号
    },
    {
      name:'data',
      path:'/data',
      component:Layout,
      redirect:'/data/data-center',
      children:[
        {name:'Data-center',path:'data-center',component: DateCenter }, // 数据中心首页
        {name:'Data-summary',path:'data-summary',component:DataSummary}, // 数据总览
        {
          name:'Beike', // 教学备课数据
          path:'beike',
          component: Beike,
          redirect: 'beike/download-source',
          children:[
            {name:'DownloadSource',path:'download-source',component: DownloadSource }, // 资源下载
            {name:'DownloadPaper',path:'download-paper',component:DownloadPaper}, // 组卷下载
            {name:'LocalSource',path:'local-source',component:LocalSource}, // 校本资源
          ]
        },
        {
          name:'Test', // 智慧作业考试数据
          path:'test',
          component: Test,
          redirect: 'test/Exam',
          children:[
            {name:'Work',path:'work',component: Work}, // 作业数据
            {name:'Exam',path:'exam',component:Exam} // 考试数据
          ]
        },
        {
          name:'Judgment', // 评价数据
          path:'judgment',
          component: Judgment,
          redirect: 'judgment/judge-data',
          children:[
            {name:'JudgeData',path:'judge-data',component: JudgeData}, // 教学评价数据
            {name:'QualityJudge',path:'quality-judge',component:QualityJudge}, // 综合素质评价
            {name:'Growth',path:'growth',component:Growth} // 教师成长档案
          ]
        },
        {name:'LessonPeriod',path:'lesson-period',component:LessonPeriod} //课时统计
      ]
    },
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js